export const MAX_SEATS = 7;
export const DEALER_SEAT = 'd';
